import PaginacaoListagem from '@/core/store/default/paginacaoListagem'

export default {
	paginacao: PaginacaoListagem(['orgao'], 5, 'ASC'),
	datasource: [],
	totalElements: 0,
	totalPages: 0,
	filtro: {
		orgaoCessionario: {},
		campoBusca: null,
		idCedente: null,
		idAta: null,
		idItemAta: null,
		tipoAlteracaoSaldo: null,
	},
	orgaoCedente: {
		idUo: null,
		sigla: null,
		estoque: null,
		tipoAlteracaoSaldo: null,
	},
	transferirSaldo: {
		idItemAta: null,
		idUoCessionario: null,
		idUoCedente: null,
		quantidadeTransferencia: null,
		numeroOficio: null,
		justificativa: '',
	},
}
